import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HeaderComponent } from '../../../../shared/components/header/header.component';
import { LoadingBoxComponent } from '../../../../shared/components/loading-box/loading-box.component';
import { OrigemDocumentoFiscalEmitidoEnum } from '../../../../shared/enums/repo-dfe/origem-documento-fiscal-emitido.enum';
import { FuncionalidadeEnum } from '../../../../shared/enums/usuario/funcionalidade.enum';
import { ModuloEnum } from '../../../../shared/enums/usuario/modulo.enum';
import { AlertService, AlertType } from '../../../../shared/services/alert.service';
import { PainelContadorService } from '../../../../shared/services/apis/repo-dfe/painel-contador.service';
import { DetalheNFeEmitidoResponse } from '../../../../shared/services/responses/repo-dfe/detalhe-nfe-emitido.response';
import { NFeDetalheEmitidoComponent } from '../nfe-detalhe-emitido/nfe-detalhe-emitido.component';

@Component({
  selector: 'app-detalhe-nfe-emitido', standalone: true,
  imports: [HeaderComponent, LoadingBoxComponent, NFeDetalheEmitidoComponent],
  templateUrl: './detalhe-nfe-emitido.component.html',
  styleUrls: ['./detalhe-nfe-emitido.component.css']
})
export class DetalheNFeEmitidoComponent implements OnInit {
  readonly moduloEnum = ModuloEnum.NotasFiscais;
  readonly funcionalidadeEnum = FuncionalidadeEnum.NotasFiscais_PainelContador;
  isLoading = true;
  documento: DetalheNFeEmitidoResponse | null = null;

  constructor(private route: ActivatedRoute, private router: Router,
    private service: PainelContadorService, private alert: AlertService) { }

  ngOnInit(): void {
    const id = Number(this.route.snapshot.paramMap.get('idNFeEmitido'));
    const origem = Number(this.route.snapshot.queryParamMap.get('origemDocumentoFiscalEmitido'));
    if (!id || origem !== OrigemDocumentoFiscalEmitidoEnum.EstruturaAntiga) {
      this.alert.show('Erro', 'NF-e emitida inválida.', AlertType.error);
      this.router.navigate(['/notas-fiscais/painel-contador']);
      return;
    }
    this.service.obterNFeEmitido(id, origem).subscribe({
      next: response => {
        this.isLoading = false;
        if (response.isError) {
          this.alert.show('Aviso', response.errorDescription, AlertType.warning);
          this.router.navigate(['/notas-fiscais/painel-contador']);
          return;
        }
        this.documento = response;
      },
      error: error => { this.isLoading = false; this.alert.show('Erro inesperado', error.message, AlertType.error); }
    });
  }
}
